export const ISO8601_DATE_REGEX =
    /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;

export class DateUtils {

    public static parseDateAndTime(datestr: string) {
        let match: RegExpMatchArray;
        if ((typeof datestr === 'string') && (match = datestr.match(ISO8601_DATE_REGEX))) {
            return DateUtils.isoStringToDate(match);
        }
    }

    private static isoStringToDate(match: RegExpMatchArray): Date {
        const date = new Date(0);
        let tzHour = 0;
        let tzMin = 0;

        // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
        const dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
        const timeSetter = match[8] ? date.setUTCHours : date.setHours;

        // if there is a timezone defined like "+01:00" or "+0100"
        if (match[9]) {
            tzHour = +(match[9] + match[10]);
            tzMin = +(match[9] + match[11]);
        }
        dateSetter.call(date, +(match[1]), +(match[2]) - 1, +(match[3]));
        const h = +(match[4] || '0') - tzHour;
        const m = +(match[5] || '0') - tzMin;
        const s = +(match[6] || '0');
        const ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
        timeSetter.call(date, h, m, s, ms);
        return date;
    }

    public static getStartDateForMonthView(date: Date): Date {
        let temp_date = new Date(date);
        temp_date.setDate(1);
        let startDate = new Date(temp_date.getFullYear()
            , temp_date.getMonth()
            , ((temp_date.getDay() != 0 ? temp_date.getDay() - 1 : 6) * -1) + 1);
        return startDate;
    }

    public static getEndDateForMonthView(date: Date): Date {
        let temp_date = new Date(date);
        temp_date.setDate(1);
        let endDate = new Date(temp_date.getFullYear()
            , temp_date.getMonth() + 1
            , 0);
        if (endDate.getDay() != 0) {
            endDate.setDate(7 - endDate.getDay());
            endDate.setMonth(endDate.getMonth() + 1);
        }
        return endDate;
    }

    public static DateToISOString(date: Date): string {
        let new_date = new Date(date);
        new_date.setHours(0, 0, 0, 0);
        return new Date(new_date.getTime() - new_date.getTimezoneOffset() * 60000).toISOString();
    }
}